import './index.scss'

window.addEventListener(
  'scroll',
  () => {
    const scrollTop =
      document.body.scrollTop || document.documentElement.scrollTop
    const totalScrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight

    let pageScrollProgress = scrollTop / totalScrollHeight

    // If there's not much to scroll, don't bother with scroll progress.
    if (totalScrollHeight < 300) {
      pageScrollProgress = 0
    }

    document.body.style.setProperty(
      '--page-scroll-progress',
      pageScrollProgress
    )
  },
  { passive: true }
)
